var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Accordion',{attrs:{"title":"By Operating System","subtitle":"What operating systems are being used?","item-data":_vm.itemData}})
}
var staticRenderFns = []

export { render, staticRenderFns }